<template>
  <v-container fluid pa-0 ma-0>
    <Loading :isLoading="isCurrentUserLoading">
      <PageHeader :title="welcome()" subtitle="Your Dashboard Overview"></PageHeader>
      <homepage-layout></homepage-layout>
    </Loading>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import Loading from "@/components/shared/Loading.vue"
import PageHeader from "@/components/PageHeader.vue"
import HomepageLayout from "@/components/homepage/HomepageLayout.vue"
import Vue from 'vue'

export default {
  name: "dashboard-overview",
  components: {
    PageHeader,
    Loading,
    HomepageLayout
  },
  mounted() {
    Vue.store.dispatch('setPageTitle', "Dashboard Overview")
  },
  computed: mapState({
    currentUser: state => state.currentUser,
    isCurrentUserLoading: state => state.currentUser.isCurrentUserLoading,
    section: state => state.route.params.section
  }),
  methods: {
    welcome() {
      return `Welcome back ${this.currentUser.me.displayName}`
    }
  },
  async beforeRouteEnter(to, from, next) {
    Vue.store.dispatch("setupTimeline", { timelineType: "user" })
    next()
  }
}
</script>
